
(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('grcControlTest', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addControl = '&';
        directiveScope.readOnly = '@';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', '$state', '$stateParams', 'grcGovernanceProcessService', 'grcControlService',
            function ($rootScope, $scope, $controller, $state, $stateParams, grcGovernanceProcessService, grcControlService) {
                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/control/grcControlTest.[Template].tpl.html';
                // Permissions default values
                $scope.boxFeatureRole = $scope.boxFeatureRole || 'ControlGrpBusinessUnit_GovernanceManagement';
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'ControlTest';

                $controller('BoxTmplController', { $scope: $scope });

                $scope.canEdit = $scope.boxPermissions.Edit;

                $scope.$watch('readOnly', function() {
                    if (typeof $scope.readOnly === 'string') {
                        $scope.readOnly = $scope.readOnly === 'true';
                    }
                });

                // Page is dirty
                $scope.ctxtDir                  = {};
                $scope.ctxtDir.needSaveChanges  = false;
                $scope.ctxtDir.showNavCollapsed = true;

                $scope.pageIsDirty = function () {
                    $scope.ctxtDir.needSaveChanges = true;
                    $rootScope.$broadcast('page-is-dirty');
                };
                $scope.pageIsNotDirty = function () {
                    $scope.ctxtDir.needSaveChanges = false;
                    $rootScope.$broadcast('page-is-not-dirty');
                };

                // Page is loading
                $scope.isLoading = false;

                // Custom Information
                $scope.view = {};

                // When Control
                if (!_.isUndefined($scope.boxModel.ControlID)) {
                    // Get control tests
                    grcControlService.getControlTests($scope.boxModel.ControlID, { ignoreError: true })
                        .then(function (controlTests) {
                            $scope.controlTests = controlTests;
                            $scope.readOnly = !$scope.boxPermissions.Edit || $scope.readOnly || $scope.boxModel.IsClosed
                                || ($scope.boxModel.Control && $scope.boxModel.Control.IsClosed);
                        });
                }

                // When retrieve tests results
                if (!_.isUndefined($scope.boxContext) && $scope.boxContext.WithTestResults == true) {
                    grcControlService.getTestResults($scope.boxModel.ControlID, $scope.boxModel.ControlTestID, { ignoreError: true })
                        .then(function (testResults) {
                            $scope.testResults = testResults;
                        });
                }

                // Show Control Status
                $scope.showControlStatus = function () {
                    if (_.isUndefined($scope.controlToAssess)) return;
                    if (!$scope.controlToAssess.Assessment.ControlStatus) return;

                    return $scope.controlToAssess.Assessment.IsTesting;
                };

                // Cancel Update Control Test
                $scope.cancelUpdateControlTest = function () {
                    $scope.pageIsNotDirty();
                    $scope.controlTestToUpdate = null;
                    $scope.view.isEditingControlTest = false;
                };

                // Edit control test
                $scope.editControlTest = function (controlTest) {

                    $scope.boxItemClick({ item: controlTest });
                    $scope.pageIsDirty();
                };

                // Show Nav Collapsed?
                $scope.showNavCollapsed = function () {
                    return $scope.ctxtDir.showNavCollapsed;
                };

                // Toggle Nav Collapse
                $scope.toggleNavCollapse = function ($event) {
                    $event.stopPropagation();
                    $scope.ctxtDir.showNavCollapsed = !$scope.ctxtDir.showNavCollapsed;
                };
            }],

            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();